import { cx } from '@emotion/css';
import { forwardRef } from 'react';

import Header from '../Header';

import LeftArrowIcon from 'assets/ic_back.png';

import { backButtonCx, mainCx, pageCx, titleBar, toolbar } from './styles';
import { PageProps } from './types';

const Page = forwardRef<HTMLDivElement, PageProps>((props: PageProps, ref) => {
  const {
    useHeader,
    title,
    children,
    className,
    contentClassName,
    onClickBack,
    ...resProps
  } = props;

  return (
    <div ref={ref} className={cx('page', className, pageCx)} {...resProps}>
      {useHeader && <Header />}
      <main
        className={cx(mainCx, contentClassName, { ['with-header']: useHeader })}
      >
        {title && (
          <div className={toolbar}>
            {onClickBack ? (
              <img
                src={LeftArrowIcon}
                className={backButtonCx}
                onClick={onClickBack}
              />
            ) : null}
            <h2 className={titleBar}>{title}</h2>
          </div>
        )}
        {children}
      </main>
    </div>
  );
});

export default Page;
